var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ask-anything-fullpage"},[_c('div',{staticClass:"ask-anything-body"},[_c(_setup.AskMain),_vm._v(" "),_c(_setup.AskSide)],1),_vm._v(" "),_c(_setup.AskAgreementModal)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }